var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBloomIconLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#5062F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.82 4C8.37744 4 9.64 5.26256 9.64 6.82V8.08C9.64 9.33921 10.6608 10.36 11.92 10.36H13.18C14.7374 10.36 16 11.6226 16 13.18C16 14.7374 14.7374 16 13.18 16C11.6226 16 10.36 14.7374 10.36 13.18V11.92C10.36 10.6608 9.33921 9.64 8.08 9.64H6.82C5.26256 9.64 4 8.37744 4 6.82C4 5.26256 5.26256 4 6.82 4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.52 6.82C15.52 8.11235 14.4723 9.16 13.18 9.16C11.8877 9.16 10.84 8.11235 10.84 6.82C10.84 5.52765 11.8877 4.48 13.18 4.48C14.4723 4.48 15.52 5.52765 15.52 6.82Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82 15.52C8.11235 15.52 9.16 14.4723 9.16 13.18C9.16 11.8877 8.11235 10.84 6.82 10.84C5.52765 10.84 4.48 11.8877 4.48 13.18C4.48 14.4723 5.52765 15.52 6.82 15.52Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloomIconLarge);
export default __webpack_public_path__ + "static/media/bloomIconLarge.a706fdbdbb9d0fa51a58270da95fcaea.svg";
export { ForwardRef as ReactComponent };